/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmAddressSummaryInfo } from './EvmAddressSummaryInfo';

export type EvmTokenItemProfileInfo = {
    TKNCTR: EvmAddressSummaryInfo;
    IMG: string;
    TKNID: string;
    TKNM: string;
    TKIMG: string;
    TKDESC: string;
    OWN: string;
    CRT: EvmAddressSummaryInfo;
    TKNST: EvmTokenItemProfileInfo.TKNST;
    CHN: EvmTokenItemProfileInfo.CHN;
    QTY: string;
    LT: string;
    AG: string;
    UT: number;
};

export namespace EvmTokenItemProfileInfo {

    export enum TKNST {
        NA = 'NA',
        CA = 'CA',
        ERC20 = 'ERC20',
        ERC721 = 'ERC721',
        ERC1155 = 'ERC1155',
    }

    export enum CHN {
        DEFAULT = 'DEFAULT',
        DEFAULT_EVM = 'DEFAULT_EVM',
        NEXON = 'NEXON',
        POLYGON = 'POLYGON',
        BASE = 'BASE',
        APTOS = 'APTOS',
        APTOS_DEVNET = 'APTOS_DEVNET',
        ZEROG = 'ZEROG',
        ZEROG_TESTNET = 'ZEROG_TESTNET',
        BABYLON = 'BABYLON',
        BABYLON_TESTNET = 'BABYLON_TESTNET',
        HUMANITY = 'HUMANITY',
        HUMANITY_TESTNET = 'HUMANITY_TESTNET',
        KITE = 'KITE',
        KITE_TESTNET = 'KITE_TESTNET',
        SOMNIA = 'SOMNIA',
    }


}

